"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75],{

/***/ 10075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionArticleAuthor": function() { return /* binding */ SectionArticleAuthor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61349);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);





const Wrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    padding: "$24 0 $32 0",
    borderTop: "1px solid $black",
    borderBottom: "1px solid $black",
    "@lg": {
        padding: "$32 0 $48 0"
    }
});
const AuthorsWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "row",
    justifyContent: "start",
    gridRowGap: "$40",
    gridColumnGap: "$40"
});
const Author = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridTemplate: "\n                'avatar details'\n                '. description'\n              ",
    alignItems: "center",
    gridTemplateColumns: "60px auto",
    gridRowGap: "$8",
    gridColumnGap: "$32"
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    textTransform: "uppercase",
    projectFont: "ui03",
    marginBottom: "$32"
});
const Avatar = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$rMax",
    width: 60,
    height: 60,
    gridArea: "avatar"
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "ui01"
});
const Positon = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_05"
});
const Details = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    gridArea: "details"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    gridArea: "description",
    projectFont: "body04",
    maxWidth: "70ch",
    color: "$white"
});
const SectionArticleAuthor = (param)=>{
    let { authors  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("article");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
        type: "RICH_TEXT_MD",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrap, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: t("writtenBy")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthorsWrapper, {
                        children: authors && (authors === null || authors === void 0 ? void 0 : authors.map((author, index)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Author, {
                                as: (author === null || author === void 0 ? void 0 : author.linkedin) ? (next_link__WEBPACK_IMPORTED_MODULE_4___default()) : "div",
                                href: author === null || author === void 0 ? void 0 : author.linkedin,
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                                        children: (author === null || author === void 0 ? void 0 : author.avatar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                                            ...author === null || author === void 0 ? void 0 : author.avatar,
                                            sizes: "60px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Details, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                                children: author === null || author === void 0 ? void 0 : author.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Positon, {
                                                children: author === null || author === void 0 ? void 0 : author.position
                                            })
                                        ]
                                    }),
                                    (author === null || author === void 0 ? void 0 : author.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .YI, {
                                            value: author === null || author === void 0 ? void 0 : author.description,
                                            appearance: "plain"
                                        })
                                    })
                                ]
                            }, "".concat(author === null || author === void 0 ? void 0 : author.name, "-").concat(index));
                        }))
                    })
                ]
            })
        })
    });
};


/***/ })

}]);